// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__XoeOO","Btn":"style_Btn__Flgvm"};